// Cached port-cost rows are reused for 8 days. The warm cron runs weekly
// (168 h cadence), so 192 h leaves ~24 h headroom for a missed run plus the
// duration of the run itself (~5000 entries × (6 s pacing + ~2 s call
// latency) ≈ 11 h).
export const MARCURA_PORT_COST_CACHE_TTL_HOURS = 192;
export const MARCURA_PORT_COST_CACHE_TTL_MS =
  MARCURA_PORT_COST_CACHE_TTL_HOURS * 60 * 60 * 1000;

// Marcura tightened their rate limits, so port-cost fetches now run strictly
// one at a time. Pacing is enforced via MARCURA_FETCH_DELAY_MS between calls.
export const MARCURA_FETCH_CONCURRENCY = 1;

// Inter-call delay applied between consecutive Marcura port-cost requests.
// 6 s pacing × ~5000 entries ≈ ~11 h, which fits within the weekly window
// and stays comfortably under our worker timeout headroom.
export const MARCURA_FETCH_DELAY_MS = 6000;

// Refresh entries cached older than this. Set just under the 168 h weekly
// cadence so the next Sunday-night warm run picks them up; the 12 h gap
// (168 - 156) absorbs cron jitter and partial run completion.
export const MARCURA_PORT_COST_WARM_THRESHOLD_HOURS = 156;

// Entries per warmCache call. 25 × ~8s ≈ 3.5min, under the ~5min timeout.
export const MARCURA_WARM_CHUNK_SIZE = 25;

// Hard ceiling on the resolver's batchSize so no caller can collapse chunking into one 11h call.
export const MARCURA_WARM_CHUNK_SIZE_MAX = 200;

export const portCostPairKey = (locationId: number, assortmentId: number) =>
  `${locationId}_${assortmentId}`;
